import { defineComponent, toRef } from 'vue';
import { FLOW_CONTEXT_INJECT_KEY } from './flowDesignerContext.js';

/**
 * Provides flowDesignerContext to descendants (SchemaForm + UserControl + PropertyGrid trees).
 * Use around FlowV2 icon property editors.
 */
export const FlowContextProvider = defineComponent({
    name: 'FlowContextProvider',
    props: {
        context: { type: Object, default: null },
    },
    provide() {
        return {
            [FLOW_CONTEXT_INJECT_KEY]: toRef(this, 'context'),
        };
    },
    setup(props, { slots }) {
        return () => slots.default?.() ?? null;
    },
});

export default FlowContextProvider;
